
const {min, max} = Math

export default function clamp(n, lower, upper) {
  return max(lower, min(upper, n))
}
